export default "__VITE_ASSET__Ba_fHRXX__"